<template>
  <div class="live_apply_box my_container"
  v-loading="loading"
  element-loading-text="拼命加载中"
  element-loading-spinner="el-icon-loading">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>发布直播</span>
        <el-divider></el-divider>
      </p>
    </div>
    <el-form
    method="POST"
    :model="apply"
    :rules="rules"
    label-position="left"
    label-width="70px"
    ref="liveForm"
    @submit.prevent="submitForm"
    :status-icon=true :hide-required-asterisk=true>
      <el-form-item label="直播标题" prop="room_title">
          <el-input type="text" v-model="apply.room_title"></el-input>
      </el-form-item>
      <el-form-item label="直播简介" prop="room_content">
          <el-input type="textarea" v-model="apply.room_content"></el-input>
      </el-form-item>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item label="直播时间" prop="ymd">
            <el-date-picker type="datetime"
            :picker-options="pickerOptions0"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="apply.ymd"
            placeholder="选择直播日期时间"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
         <el-form-item label-width="100px" label="预计直播时长" prop="room_duration">
         <el-select v-model="apply.room_duration" placeholder="选择预计直播时长">
            <el-option
              v-for="item in roomDuration"
              :key="item.value"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
         </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="封面上传">
        <upload-view v-if="imgOnOff" :filestype="filestype" :imgurl="apply.room_img" :imgtext="filesText" @files = "filesUrl"></upload-view>
      </el-form-item>
      <el-form-item label="所属板块" prop="nav_id">
        <el-cascader class="el-select"
        v-model = "apply.model_arr"
        :options="modelOptionsList"
        :props="modelProps"
        @change="modelChange">
        </el-cascader>
      </el-form-item>
      <el-form-item v-show="apply.nav_id === 15" label="参会人数" prop="num">
        <el-input-number v-model="apply.num" :min="1" :max="15" label="选择参会人数,最大不能超过15人"></el-input-number>
      </el-form-item>
      <el-form-item label="添加标签" prop="label">
        <el-select
            v-model="apply.tag_arr"
            multiple
            filterable
            default-first-option
            :multiple-limit = 5
            placeholder="最多可选取5个标签">
            <el-option
              v-for="item in labelOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <div class="rg_form_box_form_item">
          <el-button v-show="subBtnOnOff" type="primary" class="rg_form_box_form_sub" @click="submitForm('liveForm')">提交</el-button>
          <el-button v-show="!subBtnOnOff" type="primary" :loading="true">提交中</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import imgUpload from '../Public/imgUpload.vue'
export default {
  components: {
    uploadView: imgUpload
  },
  data () {
    return {
      imgOnOff: false, // 是否开始渲染图片上传组件
      filestype: 'liveBackground', // 文件上传类型为 直播背景图片
      filesText: '图片上传建议尺寸740*416px或16:9，JPG、PNG格式，上传图片大小不能超过 3MB！', // 文件上传类型为 直播背景图片
      roomDuration: [], // 时长的循环
      modelProps: { // 板块选择器配置
        value: 'id',
        label: 'name',
        children: 'model'
      },
      modelOptionsList: [], // 板块选择数组
      labelOptions: [], // 标签列表
      apply: {
        llb_id: '', // 编辑获取id
        room_title: '', // 直播标题
        room_content: '', // 直播简介
        ymd: this.mycommon.getNowTime(), // 直播日期
        start_ymd: '', // 直播日期
        start_time: '', // 直播时间
        room_duration: '', // 直播时长
        model_arr: [], // 板块选择绑定值
        nav_id: '',
        union_id: '', // 联盟id
        research_id: '', // 研究院id
        num: 0, // 预计参会人数
        room_img: '', // 封面
        tag_arr: '', // 标签数组
        tag_id: '', // 标签
        is_img: false,
        type: 1 // 直播类型  1视频   2图文
      },
      rules: {
        room_title: [{ required: true, message: '请输入直播标题', trigger: 'blur' }],
        room_content: [{ required: true, message: '请输入直播简介', trigger: 'blur' }],
        nav_id: [{ required: true, message: '请选择所属板块', trigger: 'change' }],
        ymd: [{ required: true, message: '请选择直播日期', trigger: 'change' }],
        room_duration: [{ required: true, message: '请选择预计直播时长', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择直播时间', trigger: 'blur' }],
        tag_id: [{ required: true, message: '请选择标签', trigger: 'change' }]
      },
      // 限制日期选择为当前日期之后
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      loading: true, // 页面加载动画
      // 提交按钮加载
      subBtnOnOff: true
    }
  },
  created () {
    const vueThat = this
    // 进入组件对时长进行循环
    for (let i = 1; i < 13; i++) {
      vueThat.roomDuration.push(i)
    }
    vueThat.apply.llb_id = vueThat.$route.query.id
    this.getModel()
    this.getLabel()
  },
  methods: {
    // 获取选择模块
    getModel () {
      const vueThat = this
      const typeId = 1
      vueThat.myApi.getModel({ type_id: typeId }).then(function (res) {
        if (res.data.code === 200) {
          const navList = res.data.data.nav_list
          const unionList = res.data.data.union_list
          const researchList = res.data.data.research_list
          for (let i = 0; i < navList.length; i++) {
            const model = navList[i].model
            for (let n = 0; n < model.length; n++) {
              const sonModel = model[n].model
              if (sonModel !== undefined && sonModel.length > 0) {
                for (let m = 0; m < sonModel.length; m++) {
                  if (sonModel[m].is_use === 0) {
                    sonModel[m].name += '(暂不支持)'
                    sonModel[m].disabled = true
                  }
                }
              } else {
                if (model[n].is_use === 0) {
                  model[n].name += '(暂不支持)'
                  model[n].disabled = true
                }
              }
            }
          }
          if (unionList.length > 0 && navList[1].model.length > 0) {
            for (let i = 0; i < unionList.length; i++) {
              unionList[i].model = navList[1].model
            }
            navList[1].model = unionList
          } else {
            navList[1].disabled = true
          }
          if (researchList.length > 0 && navList[2].model.length > 0) {
            for (let i = 0; i < researchList.length; i++) {
              researchList[i].model = navList[2].model
            }
            navList[2].model = researchList
          } else {
            navList[2].disabled = true
          }
          vueThat.modelOptionsList = navList
        }
      })
    },
    // 模块选定后的回调
    modelChange (value) {
      if (value.length > 0) {
        if (value[0] === 3) {
          this.apply.union_id = value[1]
          this.apply.nav_id = value[2]
        } else if (value[0] === 4) {
          this.apply.research_id = value[1]
          this.apply.nav_id = value[2]
        } else {
          this.apply.nav_id = value[1]
        }
      }
    },

    // 获取标签
    getLabel () {
      const vueThat = this
      vueThat.myApi.getLabel().then(function (res) {
        if (res.data.code === 200) {
          vueThat.labelOptions = res.data.data
          if (vueThat.apply.llb_id !== undefined) {
            vueThat.myApi.getEditLive({ llb_id: vueThat.apply.llb_id }).then((res) => {
              if (res.data.code === 200) {
                for (const key in res.data.data) {
                  if (key === 'tag') {
                    for (let i = 0; i < res.data.data[key].length; i++) {
                      vueThat.apply.tag_arr.push(res.data.data[key][i].tag_id)
                    }
                  } else {
                    vueThat.apply[key] = res.data.data[key]
                  }
                }
              }
              vueThat.loading = false // 关闭加载动画
              vueThat.imgOnOff = true // 开始渲染封面上传组件
            })
          } else {
            vueThat.loading = false // 关闭加载动画
            vueThat.imgOnOff = true // 开始渲染封面上传组件
          }
        }
      })
    },
    // 获取上传后的文件地址
    filesUrl: function (data, type) {
      this.apply.room_img = data
    },
    // 提交
    submitForm: function (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        const newDate = vueThat.apply.ymd.split(' ')
        vueThat.apply.start_ymd = newDate[0].split('-').join('')
        vueThat.apply.start_time = vueThat.mycommon.getUnixTime(vueThat.apply.ymd)
        vueThat.apply.tag_id = vueThat.apply.tag_arr.join(',')
        if (valid) {
          vueThat.subBtnOnOff = false
          try {
            if (vueThat.apply.llb_id !== undefined) {
              await vueThat.subFun('apply/subEditLive', vueThat.apply)
            } else {
              await vueThat.subFun('apply/liveSub', vueThat.apply)
            }
          } catch (e) {}
        } else {
          return false
        }
      })
    },
    // 点击提交函数
    subFun: function (url, data) {
      const vueThat = this
      vueThat.$store.dispatch(url, data)
        .then(function (res) {
          if (res.data.code === 200) {
            vueThat.$alert('提交申请成功，请耐心等待审核通过', '温馨提示', {
              type: 'success',
              iconClass: 'iconfont icon-icon_richeng_btn_pass',
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                vueThat.$store.commit('editPersonalMeunAct', 'liveList')
                vueThat.$router.push({ name: 'LiveList' })
              }
            })
          } else {
            vueThat.subBtnOnOff = true
          }
        })
    }
  }
}
</script>

<style scoped="scoped">
  .el-picker-panel__link-btn{
    display: none;
  }
</style>
